import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Button, IconButton } from '@hyperflake/react-ui-library';
import { PlusIcon } from '@icon/index';
import { AssetPurchaseOrderList } from 'modules/asset-purchase-order/components/AssetPurchaseOrderList/AssetPurchaseOrderList';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { SiteRecceList } from 'modules/site-recce/components/SiteRecceList/SiteRecceList';
import { Link, useNavigate, useParams } from 'react-router-dom';

const AssetPurchaseOrderPage = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();

    return (
        <PageTemplate>
            <div className="flex justify-between">
                <PageHeading>Purchase Orders</PageHeading>

                {hasPermission(PermissionEnum.ASSET_PURCHASE_ORDER_CREATE) && (
                    // <Button onClick={addClientDialog.show}>Add Client</Button>
                    <Link
                        to={`/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order/add`}
                    >
                        <Button
                            onClick={() =>
                                navigate(
                                    `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order/add`
                                )
                            }
                        >
                            Add Purchase Order
                        </Button>
                    </Link>
                )}
            </div>

            <AssetPurchaseOrderList />
        </PageTemplate>
    );
};

export default AssetPurchaseOrderPage;
